import axios from 'axios';
import loader from './loader';

const dataLoader = (function(){

    function saveData(data, respData) {
        if (!data) {
            data = {};
        }

        for (let key of Object.keys(respData)) {
            if (typeof data[key] === 'undefined') {
                // Main level
                data[key] = respData[key];
            } else {
                // Sub level
                for (let dataKey of Object.keys(respData[key])) {
                    data[key][dataKey] = respData[key][dataKey];
                }
            }
        }

        return data;
    }

    function loadData(params = {}) {
        return axios({
            method: 'get',
            url: '/stage-ajax/get-covid/',
            responseType: 'json',
            params: params
        });
    }

    function endLoader(initialLoad, page) {
        if (initialLoad) {
            const main = document.getElementById('pages');
            loader.end(main);
        } else {
            loader.end(page);
        }
    }

    function loadEndpointData(data, dataEndpoints, callback, callbackParams = {}, endpointRequestParams = null, initialLoad = false) {
        if (dataEndpoints.length) {
            // Some data is missing & needs to be loaded
            const requests = [];
            for (let i = 0; i < dataEndpoints.length; i++) {
                let endpoint = dataEndpoints[i];
                let params = {
                    endpoints: [endpoint],
                    firstDate: window.config.dataFirstDate.format('YYYY-MM-DD'),
                    dataTimestamp: window.config.dataTimestamp
                };

                if (endpointRequestParams && typeof endpointRequestParams[i] !== 'undefined') {
                    params = Object.assign(params, endpointRequestParams[i]);
                }

                requests.push(loadData(params));
            }

            // Wait for all requests to finish
            Promise.all(requests).then(function (responses) {
                for (let resp of responses) {
                    data = saveData(data, resp.data);
                }

                callback(data, callbackParams);
                if (callbackParams && callbackParams.page) {
                    endLoader(initialLoad, callbackParams.page);
                }
            });
        } else {
            callback(data, callbackParams);
            if (callbackParams && callbackParams.page) {
                endLoader(initialLoad, callbackParams.page);
            }
        }
    }

    function getPageDataEndpoints(data, id) {
        // Required data for each page
        const requiredData = [];
        if (id === window.config.defaultPageId) {
            requiredData.push('confirmedDay', 'hospitalWeek', 'deadDay','sewageWeek','tests','vaccinations'); // vaccinationsDose
        } else if (id === window.config.hospitalPageId) {
            requiredData.push('hospitalWeek', 'hospitalAges', 'hospitalAreas', 'deadDay', 'deadFull');
        } else if (id === window.config.regionPageId) {
            requiredData.push('confirmedDay','confirmedArea');
        } else if (id === window.config.municipalityPageId) {
            requiredData.push('municipalities');
        } else if (id === window.config.agePageId) {
            requiredData.push('ages');
        } else if (id === window.config.vaccinePageId) {
            requiredData.push('vaccinations'); // ('vaccinationsDose', 'vaccinationsFull');
        } else if (id === window.config.sewagePageId) {
            requiredData.push('sewageWeek','sewageFull');
        }

        if (!data) {
            return requiredData; // Get all
        }

        const dataEndpoints = []
        for (let dataKey of requiredData) {
            if (dataKey === 'confirmedDay') {
                if (!(typeof data.confirmed !== 'undefined' && typeof data.confirmed.days !== 'undefined')) {
                    dataEndpoints.push(dataKey);
                }
            } else if (dataKey === 'confirmedArea') {
                if (!(typeof data.confirmed !== 'undefined' && typeof data.confirmed.areaDays !== 'undefined')) {
                    dataEndpoints.push(dataKey);
                }
            } /*else if (dataKey === 'medicalDay') {
                if (!(typeof data.medical !== 'undefined' && typeof data.medical.days !== 'undefined')) {
                    dataEndpoints.push(dataKey);
                }
            } else if (dataKey === 'medicalArea') {
                if (!(typeof data.medical !== 'undefined' && typeof data.medical.areas !== 'undefined')) {
                    dataEndpoints.push(dataKey);
                }
            }*/ else if (dataKey === 'hospitalWeek') {
                if (!(typeof data.hospital !== 'undefined' && typeof data.hospital.weeks !== 'undefined')) {
                    dataEndpoints.push(dataKey);
                }
            } else if (dataKey === 'hospitalAges') {
                if (!(typeof data.hospital !== 'undefined' && typeof data.hospital.ages !== 'undefined')) {
                    dataEndpoints.push(dataKey);
                }
            } else if (dataKey === 'hospitalAreas') {
                if (!(typeof data.hospital !== 'undefined' && typeof data.hospital.areas !== 'undefined')) {
                    dataEndpoints.push(dataKey);
                }
            } else if (dataKey === 'deadDay') {
                if (!(typeof data.dead !== 'undefined' && typeof data.dead.days !== 'undefined')) {
                    dataEndpoints.push(dataKey);
                }
            } else if (dataKey === 'deadFull') {
                if (!(typeof data.dead !== 'undefined' && typeof data.dead.months !== 'undefined')) {
                    dataEndpoints.push(dataKey);
                }
            } else if (dataKey === 'municipalities') {
                if (!(typeof data.municipalities !== 'undefined')) {
                    dataEndpoints.push(dataKey);
                }
            } else if (dataKey === 'ages') {
                if (!(typeof data.ages !== 'undefined')) {
                    dataEndpoints.push(dataKey);
                }
            } else if (dataKey === 'tests') {
                if (!(typeof data.tests !== 'undefined')) {
                    dataEndpoints.push(dataKey);
                }
            } else if (dataKey === 'vaccinationsDose') {
                if (!(typeof data.vaccines !== 'undefined' && typeof data.vaccines.doses !== 'undefined')) {
                    dataEndpoints.push(dataKey);
                }
            } else if (dataKey === 'vaccinationsFull') {
                if (!(typeof data.vaccines !== 'undefined' && typeof data.vaccines.ages !== 'undefined')) {
                    dataEndpoints.push(dataKey);
                }
            } else if (dataKey === 'vaccinations') {
                if (!(typeof data.vaccines !== 'undefined' && typeof data.vaccines.byWeek !== 'undefined')) {
                    dataEndpoints.push(dataKey);
                }
            } else if (dataKey === 'sewageWeek') {
                if (!(typeof data.sewage !== 'undefined' && typeof data.sewage.weeks !== 'undefined')) {
                    dataEndpoints.push(dataKey);
                }
            } else if (dataKey === 'sewageFull') {
                if (!(typeof data.sewage !== 'undefined' && typeof data.sewage.locations !== 'undefined')) {
                    dataEndpoints.push(dataKey);
                }
            }
        }

        return dataEndpoints;
    }

    return {
        saveData,
        loadData,
        getPageDataEndpoints,
        loadEndpointData
    }
})();

export default dataLoader;
